import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-e-isporuke-nabavke-modal',
  templateUrl: './modal-e-isporuke-nabavke-modal.component.html',
  styleUrls: ['./modal-e-isporuke-nabavke-modal.component.scss'],
  standalone: false
})
export class ModalEIsporukeNabavkeModalComponent implements OnInit {
  @Input() updateInputValue = new EventEmitter();
  context = localStorage.getItem('userContext');
  parsedContext = JSON.parse(this.context);

  constructor(private bsModalRef: BsModalRef) { }

  reportForm: UntypedFormGroup;

  ngOnInit(): void { }

  onSubmit() {
    if (this.reportForm.valid) {
      this.updateInputValue.emit(this.reportForm.value);
      this.closeModal();
    } else {
      this.reportForm.markAllAsTouched();
    }
  }
  closeModal() {
    this.bsModalRef.hide();
  }

}
